var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.862,
    height: 24.707,
    viewBox: "0 0 24.862 24.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_",
    "data-name": "calendar ",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39176",
    "data-name": "Group 39176",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39175",
    "data-name": "Group 39175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34138",
    "data-name": "Path 34138",
    d: "M21.836,22.959H20.307V21.608a.638.638,0,1,0-1.269,0v1.352H12.819V21.608a.638.638,0,1,0-1.269,0v1.352H5.267V21.608a.676.676,0,0,0-.635-.708A.676.676,0,0,0,4,21.608v1.352H2.532A2.733,2.733,0,0,0,0,25.825V42.277a2.691,2.691,0,0,0,2.532,2.83h19.3a2.689,2.689,0,0,0,2.532-2.823V25.825A2.723,2.723,0,0,0,21.836,22.959ZM23.1,42.277a1.347,1.347,0,0,1-1.256,1.415H2.532a1.341,1.341,0,0,1-1.263-1.408V25.825a1.376,1.376,0,0,1,1.263-1.451H4V25.4a.676.676,0,0,0,.635.708.676.676,0,0,0,.635-.708V24.374h6.282V25.4a.638.638,0,1,0,1.269,0V24.374h6.219V25.4a.638.638,0,1,0,1.269,0V24.374h1.529A1.376,1.376,0,0,1,23.1,25.825Z",
    transform: "translate(0 -20.9)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39178",
    "data-name": "Group 39178",
    transform: "translate(8.661 8.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39177",
    "data-name": "Group 39177",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34139",
    "data-name": "Path 34139",
    d: "M140.146,135h-1.238a.708.708,0,1,0,0,1.415h1.238a.708.708,0,0,0,0-1.415Z",
    transform: "translate(-138.2 -135)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39180",
    "data-name": "Group 39180",
    transform: "translate(13.022 8.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39179",
    "data-name": "Group 39179",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34140",
    "data-name": "Path 34140",
    d: "M209.746,135h-1.238a.708.708,0,0,0,0,1.415h1.238a.708.708,0,1,0,0-1.415Z",
    transform: "translate(-207.8 -135)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39182",
    "data-name": "Group 39182",
    transform: "translate(17.422 8.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39181",
    "data-name": "Group 39181",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34141",
    "data-name": "Path 34141",
    d: "M279.946,135h-1.238a.708.708,0,1,0,0,1.415h1.238a.708.708,0,0,0,0-1.415Z",
    transform: "translate(-278 -135)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39184",
    "data-name": "Group 39184",
    transform: "translate(8.661 12.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39183",
    "data-name": "Group 39183",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34142",
    "data-name": "Path 34142",
    d: "M140.146,204h-1.238a.708.708,0,1,0,0,1.415h1.238a.708.708,0,1,0,0-1.415Z",
    transform: "translate(-138.2 -204)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39186",
    "data-name": "Group 39186",
    transform: "translate(4.261 12.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39185",
    "data-name": "Group 39185",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34143",
    "data-name": "Path 34143",
    d: "M69.953,204H68.708a.708.708,0,1,0,0,1.415h1.238A.708.708,0,0,0,69.953,204Z",
    transform: "translate(-68 -204)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39188",
    "data-name": "Group 39188",
    transform: "translate(13.022 12.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39187",
    "data-name": "Group 39187",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34144",
    "data-name": "Path 34144",
    d: "M209.746,204h-1.238a.708.708,0,1,0,0,1.415h1.238a.708.708,0,1,0,0-1.415Z",
    transform: "translate(-207.8 -204)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39190",
    "data-name": "Group 39190",
    transform: "translate(17.422 12.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39189",
    "data-name": "Group 39189",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34145",
    "data-name": "Path 34145",
    d: "M279.946,204h-1.238a.708.708,0,1,0,0,1.415h1.238a.708.708,0,0,0,0-1.415Z",
    transform: "translate(-278 -204)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39192",
    "data-name": "Group 39192",
    transform: "translate(8.661 17.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39191",
    "data-name": "Group 39191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34146",
    "data-name": "Path 34146",
    d: "M140.146,272h-1.238a.708.708,0,0,0,0,1.415h1.238a.708.708,0,0,0,0-1.415Z",
    transform: "translate(-138.2 -272)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39194",
    "data-name": "Group 39194",
    transform: "translate(4.261 17.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39193",
    "data-name": "Group 39193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34147",
    "data-name": "Path 34147",
    d: "M69.953,272H68.708a.708.708,0,0,0,0,1.415h1.238A.708.708,0,0,0,69.953,272Z",
    transform: "translate(-68 -272)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39196",
    "data-name": "Group 39196",
    transform: "translate(13.022 17.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39195",
    "data-name": "Group 39195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34148",
    "data-name": "Path 34148",
    d: "M209.746,272h-1.238a.708.708,0,0,0,0,1.415h1.238a.708.708,0,0,0,0-1.415Z",
    transform: "translate(-207.8 -272)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e99fccf192e5ebcee474f10d7c41e45d.svg";
export { ForwardRef as ReactComponent };